import React from 'react';
import PropTypes from 'prop-types';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import { Link, Button } from 'components/ui';
import Modal from 'components/Modal/Modal';
import typography from 'style/typography';
import ComponentList from 'components/Content/ComponentList';
import getModal from 'services/api/cms/getModal';
import { globalModals } from 'utils/globalModals';
import ContentConstants from 'constants/content';

const { CONTEXTS } = ContentConstants;
const { COMMUNITY_RATINGS_REVIEWS } = globalModals;

class GuidelinesModalLink extends BaseClass {
    state = {
        contentData: null,
        showGuidelines: false
    };

    closeModal = () => {
        this.setState(oldState => ({ ...oldState, showGuidelines: false }));
    };

    openModal = () => {
        const { sid } = this.props.globalModals[COMMUNITY_RATINGS_REVIEWS] || {};

        if (this.state.contentData) {
            this.setState(oldState => ({ ...oldState, showGuidelines: true }));
        } else if (sid) {
            const { country, channel, language } = Sephora.renderQueryParams;
            getModal({ country, language, channel, sid })
                .then(data => {
                    this.setState({
                        showGuidelines: true,
                        contentData: data?.data
                    });
                })
                .catch(error => {
                    Sephora.logger.error('Failed to load review guidelines modal content from Contentful', error);
                });
        } else {
            Sephora.logger.error('Review guidelines modal SID not configured in globalModals.COMMUNITY_RATINGS_REVIEWS');
        }
    };

    render() {
        const { showGuidelines, contentData } = this.state;

        return (
            <>
                <Link
                    onClick={this.openModal}
                    color='blue'
                    padding={2}
                    margin={-2}
                    underline={true}
                >
                    {this.props.ratingsAndReviewsGuidelines}
                </Link>
                {showGuidelines && contentData && (
                    <Modal
                        isOpen={true}
                        onDismiss={this.closeModal}
                        width={contentData?.width || 2}
                    >
                        <Modal.Header>
                            <Modal.Title>{contentData?.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body css={typography}>
                            <ComponentList
                                items={contentData?.items}
                                context={CONTEXTS.MODAL}
                                removeFirstItemMargin={true}
                                removeLastItemMargin={true}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant='primary'
                                hasMinWidth={true}
                                children={this.props.done}
                                onClick={this.closeModal}
                            />
                        </Modal.Footer>
                    </Modal>
                )}
            </>
        );
    }
}

GuidelinesModalLink.propTypes = {
    done: PropTypes.string,
    ratingsAndReviewsGuidelines: PropTypes.string
};

export default wrapComponent(GuidelinesModalLink, 'GuidelinesModalLink', true);
